export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '汇码付',

    /** 公司名称 */
    name: '广东汇码付网络科技有限公司',
    /** 公司微信 */
    wechat: 'gzket',
    /** 公司邮箱 */
    email: 'hr@gzekt.com',
    /** 公司手机 */
    phone: '18279700888',
    /** 公司电话 */
    tel: '020-39341812',
    /** 公司地址 */
    address: '广州市番禺区小谷围街青蓝街22号B区906室',
    /** 备案号 */
    keepOnRecordIcp: '粤ICP备2023134251号',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 113.400551,
        latitude: 23.067028,
        title: '汇码付',
        address: '广州市番禺区小谷围街青蓝街22号B区906室'
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js